import React, { useState, useEffect, useMemo } from "react";
import NoDataImg from "../../../Assets/img/image 12.png";
import payout from "../../../Assets/img/vector/payout.png";
import { useLocation } from "react-router-dom";

import { MdOutlinePendingActions } from "react-icons/md";
import { GiMoneyStack } from "react-icons/gi";
import { MdOutlineAccountBalance } from "react-icons/md";

import axios from "axios";
import { BASE_URL, security_key } from "../../../global";
import { useFormik } from "formik";
import * as Yup from "yup";
import "react-toastify/dist/ReactToastify.css";
import Tooltip from "@mui/material/Tooltip";
import { Button } from "react-bootstrap";
import PaypalRedirectRequest from "../../Paypal/PaypalRedirectRequest";
import { Modal, Tab, Tabs } from "react-bootstrap";
import ArticleViewHistory from "../ArticleMangement/ArticleViewHistory";

const Payout = () => {
    const [paymentMethod, setPaymentMethod] = useState("");
    const userKey = sessionStorage.getItem("pk_user_key");
    const [showBankFields, setShowBankFields] = useState(false);
    const [amount, setAmount] = useState("");
    const [accountNumber, setAccountNumber] = useState("");
    const [transactionPassword, setTransactionPassword] = useState("");
    const [paypalId, setPaypalId] = useState("");
    const [payouts, setPayouts] = useState([]);
    const [totalCount, setTotalCount] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [transaction, setTransaction] = useState([]);

    const [show, setShow] = useState(false);
    const [row, setRow] = useState([]);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const payerID = queryParams.get("PayerID");
    const [currentPage, setCurrentPage] = useState(1);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {
        fetchData();
        setInterval(() => {
            fetchData();
        }, 5000);
        console.log(payerID);
    }, [payerID]);

    const fetchData = async () => {
        try {
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "getAllPayout",
            });
            const output = response.data;
            setPayouts(output);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handlePaymentMethodChange = (event) => {
        const method = event.target.value;
        setPaymentMethod(method);
        if (method !== "bank") {
            setShowBankFields(false);
        }
    };

    const handleUpdateBankClick = () => {
        setShowBankFields(true);
    };

    const handleRequest = () => {
        const newPayout = {
            id: Math.random().toString(36).substr(2, 9), // Generating a random ID
            method: paymentMethod,
            amount: amount,
            status: "Pending",
            date: new Date().toLocaleDateString(),
        };

        if (paymentMethod === "bank") {
            newPayout.accountNumber = accountNumber;
            newPayout.transactionPassword = transactionPassword;
        } else if (paymentMethod === "paypal") {
            newPayout.paypalId = paypalId;
        }

        setPayouts([...payouts, newPayout]);

        // Clear form fields after submission
        setAmount("");
        setAccountNumber("");
        setTransactionPassword("");
        setPaypalId("");
        setPaymentMethod("");
        setShowBankFields(false);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const year = date.getFullYear();
        return `${month}-${day}-${year}`;
    };

    // const pendingRequest = payouts.filter((payout) => payout.status === 1).reduce((sum, payout) => sum + parseFloat(payout.amount), 0);

    // const totalPayout = payouts.filter((payout) => payout.status === 2).reduce((sum, payout) => sum + parseFloat(payout.amount), 0);

    const pendingRequest = Array.isArray(payouts)
        ? payouts.filter((payout) => payout.status === 1).reduce((sum, payout) => sum + parseFloat(payout.amount), 0)
        : 0;

    const totalPayout = Array.isArray(payouts)
        ? payouts.filter((payout) => payout.status === 2).reduce((sum, payout) => sum + parseFloat(payout.amount), 0)
        : 0;

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const [count, setCount] = useState(0);

    const filteredPayouts = useMemo(() => {
        if (count < searchTerm.length) {
            setCount(count + searchTerm.length);
            handlePageChange(1);
        } else if (searchTerm.length == 0) {
            setCount(0);
        }
        return payouts.filter((payout) => {
            const searchLower = searchTerm.toLowerCase();

            const statusText = payout.status === 1 ? "pending" : payout.status === 2 ? "completed" : "";

            return (
                (payout.first_name && payout.first_name.toLowerCase().includes(searchLower)) ||
                (payout.last_name && payout.last_name.toLowerCase().includes(searchLower)) ||
                (payout.amount && `${payout.amount}`.toLowerCase().includes(searchLower)) ||
                (payout.pr_created_on && formatDate(payout.pr_created_on).toLowerCase().includes(searchLower)) ||
                (payout.business_id && payout.business_id.toLowerCase().includes(searchLower)) ||
                (statusText && statusText.toLowerCase().includes(searchLower)) ||
                (payout.description && payout.description.toLowerCase().includes(searchLower))
            );
        });
    }, [payouts, searchTerm]);

    const ITEMS_PER_PAGE = 10;

    const paginatedMagazines = useMemo(() => {
        const start = (currentPage - 1) * ITEMS_PER_PAGE;
        const end = start + ITEMS_PER_PAGE;
        return filteredPayouts.slice(start, end);
    }, [filteredPayouts, currentPage]);

    const totalPages = Math.ceil(filteredPayouts.length / ITEMS_PER_PAGE);

    const handleViewDetails = (row) => {
        getAllPaymentData(row.fk_user_key);
        setRow(row);
        handleShow(true);
    };
    console.log("row", row);

    const getAllPaymentData = async (user_key) => {
        try {
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "getAllPaymentData",
                user_key: user_key,
            });
            const output = response.data;
            if (output.length > 0) {
                setTransaction(output.filter((row) => row.payer_user_key === userKey));
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const getAmount = (row) => {
        // if (row.payer_user_key == row.receiver_user_key) {
        //     return <span className="text-success">+${row.amount}</span>;
        // } else if (row.payer_user_key == userKey) {
        //     return <span className="text-danger">-${row.amount}</span>;
        // } else {
        //     return <span className="text-success">+${row.amount}</span>;
        // }
        return <span>${row.amount}</span>;
    };

    function convertDateTime(originalDateTime) {
        // Create a Date object from the original timestamp (assuming it's in UTC)
        let date = new Date(originalDateTime);

        // Adjust the date if necessary (e.g., use the following only if needed)
        // date.setDate(date.getDate() - 283); // Adjust days
        // date.setHours(date.getHours() - 8); // Adjust hours
        // date.setMinutes(date.getMinutes() - 23); // Adjust minutes

        // Format the date to '28 Jan 2024 11:05 AM' format
        const options = {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true, // Display 12-hour format
        };

        // Format the adjusted date
        return new Intl.DateTimeFormat("en-US", options).format(date).replace(",", "");
    }

    return (
        <>
            <section className="pb-3">
                <div className="main-content">
                    <h3 className="page-title">Payout</h3>
                    <div className="row g-2">
                        <div className="col-md-12 col-lg-4 px-2">
                            <div className="head-box p-3 d-flex">
                                <div className="icon-box bg-white">
                                    <MdOutlinePendingActions className="f-32" />
                                </div>
                                <div className="box px-2">
                                    <div className="text-box">
                                        <p>Pending Request</p>
                                        <span className="head-box-count">${pendingRequest.toFixed(2)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 col-lg-4 px-2">
                            <div className="head-box p-3 d-flex">
                                <div className="icon-box">
                                    <GiMoneyStack className="f-32" />
                                </div>
                                <div className="box px-2">
                                    <div className="text-box">
                                        <p>Total Payout</p>
                                        <span className="head-box-count">${totalPayout.toFixed(2)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 px-2 h-100">
                            <div className="m-wrapper mt-3 p-3">
                                <div className="input-group mb-3 d-flex gap-3 align-items-center justify-content-between">
                                    <div className="net-input-field">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search"
                                            aria-label="Search"
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                {/* <th className="bg-5">Transaction ID</th> */}
                                                <th className="bg-5">User Name</th>
                                                <th className="bg-5">Description</th>
                                                <th className="bg-5">Amount</th>
                                                <th className="bg-5">Paypal ID</th>
                                                <th className="bg-5">Status</th>
                                                <th className="bg-5">Requested date</th>
                                                <th className="bg-5">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {paginatedMagazines.length > 0 ? (
                                                paginatedMagazines.map((payout) => (
                                                    <tr key={payout.pk_payot_key}>
                                                        {/* <td>{payout.id}</td> */}
                                                        <td>{payout.first_name + " " + payout.last_name}</td>
                                                        <td>{payout.description}</td>
                                                        <td>${payout.amount}</td>
                                                        <td>{payout.business_id}</td>
                                                        <td>{payout.status === 1 ? "Pending" : "Completed"}</td>
                                                        <td>{formatDate(payout.pr_created_on)}</td>
                                                        <td>
                                                            <Tooltip title="View Details">
                                                                <Button
                                                                    className="md-2"
                                                                    variant="outline-dark"
                                                                    size="sm"
                                                                    onClick={() => handleViewDetails(payout)}
                                                                >
                                                                    <i class="fa-sharp fa-solid fa-eye"></i>
                                                                </Button>
                                                            </Tooltip>
                                                            <div className="mt-2">
                                                                {payout.status === 1 ? (
                                                                    <PaypalRedirectRequest
                                                                        business={payout.business_id}
                                                                        amount={payout.amount}
                                                                        receiver_user_key={payout.fk_user_key}
                                                                        payoutKey={payout.pk_payout_key}
                                                                    />
                                                                ) : (
                                                                    // If status is "Completed"
                                                                    <button
                                                                        type="button"
                                                                        disabled
                                                                        className="btn btn-dark text-white d-flex align-items-center justify-content-center fw-semibold"
                                                                    >
                                                                        Paid
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7" className="text-center">
                                                        <div className="d-flex flex-column align-items-center">
                                                            <img src={NoDataImg} alt="No data" className="img-fluid" />
                                                            <span>No Data available</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="pagination d-flex justify-content-end mb-3 my-3">
                        <Button onClick={() => handlePageChange(1)} disabled={currentPage === 1} className="btn btn-light mx-1">
                            &lt;&lt;
                        </Button>
                        <Button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="btn btn-light mx-1">
                            &lt;
                        </Button>
                        {Array.from({ length: totalPages }, (_, index) => (
                            <Button
                                key={index + 1}
                                onClick={() => handlePageChange(index + 1)}
                                className={`mx-1 ${currentPage === index + 1 ? "btn-dark text-white" : "btn-light"}`}
                            >
                                {index + 1}
                            </Button>
                        ))}
                        <Button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="btn btn-light mx-1">
                            &gt;
                        </Button>
                        <Button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} className="btn btn-light mx-1">
                            &gt;&gt;
                        </Button>
                    </div>
                </div>

                {/* Offcanvas Menu */}
                <div className="offcanvas offcanvas-end" tabIndex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
                    <div className="offcanvas-header">
                        <h5 id="offcanvasRightLabel" className="fw-bold">
                            Request Payout
                        </h5>
                        <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                    </div>
                    <div className="offcanvas-body">
                        <div className="mb-3">
                            <label htmlFor="amount" className="form-label">
                                Request Amount
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="amount"
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                                placeholder="Enter amount"
                            />
                        </div>
                        <div className="mb-3 ">
                            <label htmlFor="paymentMethod" className="form-label">
                                Payment Method
                            </label>
                            <select
                                id="paymentMethod"
                                className="form-select w-100 border border-dark"
                                value={paymentMethod}
                                onChange={handlePaymentMethodChange}
                            >
                                <option value="">Select payment method</option>
                                <option value="bank">Bank</option>
                                <option value="paypal">PayPal</option>
                            </select>
                        </div>
                        {paymentMethod === "bank" && (
                            <div className="mb-3">
                                {!showBankFields ? (
                                    <p>
                                        Update your bank details,{" "}
                                        <a href="#" className="fw-bold text-decoration-underline" onClick={handleUpdateBankClick}>
                                            click here
                                        </a>
                                    </p>
                                ) : (
                                    <>
                                        <div className="mb-3">
                                            <label htmlFor="accountNumber" className="form-label">
                                                Account Number
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="accountNumber"
                                                value={accountNumber}
                                                onChange={(e) => setAccountNumber(e.target.value)}
                                                placeholder="Enter account number"
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="transactionPassword" className="form-label">
                                                Transaction Password
                                            </label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                id="transactionPassword"
                                                value={transactionPassword}
                                                onChange={(e) => setTransactionPassword(e.target.value)}
                                                placeholder="Enter transaction password"
                                            />
                                        </div>
                                    </>
                                )}
                            </div>
                        )}
                        {paymentMethod === "paypal" && (
                            <div className="mb-3">
                                <label htmlFor="paypalId" className="form-label">
                                    PayPal ID
                                </label>
                                <input
                                    type="email"
                                    className="form-control"
                                    id="paypalId"
                                    value={paypalId}
                                    onChange={(e) => setPaypalId(e.target.value)}
                                    placeholder="Enter PayPal ID"
                                />
                            </div>
                        )}
                    </div>
                    <div className="btn-pay-home p-3">
                        <button type="button" className="btn btn-dark rounded-3" onClick={handleRequest}>
                            Request
                        </button>
                    </div>
                </div>
                {/* Offcanvas Menu End */}
                <Modal show={show} onHide={handleClose} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Requested Distributor Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Tabs defaultActiveKey="article" transition={false} id="noanim-tab-example" className="mb-3">
                            <Tab eventKey="article" title="Article History">
                                <div className="table-responsive">
                                    {/* <ArticleViewHistory /> */}
                                    {row && <ArticleViewHistory fk_user_key={row.fk_user_key} />}
                                </div>
                            </Tab>
                            <Tab eventKey="transaction" title="Transaction">
                                <div className="table-responsive">
                                    <table className="table table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th className="bg-5">Transaction ID</th>
                                                <th className="bg-5">Amount Type</th>
                                                <th className="bg-5">Amount</th>
                                                <th className="bg-5">Date of Transaction</th>
                                                <th className="bg-5">Summary</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {transaction.length > 0 ? (
                                                transaction.map((payout) => (
                                                    <tr key={payout.pk_pay_key}>
                                                        <td>{payout.transaction_id}</td>
                                                        <td>{payout.currency}</td>
                                                        <td>{payout.amount}</td>
                                                        <td>{convertDateTime(payout.txn_date)}</td>
                                                        <td>{payout.summary}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="5" className="text-center">
                                                        <div className="d-flex flex-column align-items-center">
                                                            <img src={NoDataImg} alt="No data" className="img-fluid" />
                                                            <span>No Data available</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </Tab>
                        </Tabs>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>

                <style jsx>
                    {`
                        .download-btn {
                            width: 92px;
                        }

                        .net-input-field input,
                        select {
                            width: 252px !important;
                            height: 42px;
                            padding: 11px;
                            border-radius: 4px;
                            outline: none;
                            transition: border-color 0.3s;
                        }
                        .w-90 {
                            width: 90%;
                        }
                        .money-box {
                            background-color: #d9d9d9 !important;
                        }
                        .money-box-count {
                            font-weight: 600;
                        }
                        .form-select {
                            height: inherit;
                            border-radius: 0px !important;
                            box-shadow: unset !important;
                        }
                    `}
                </style>
            </section>
        </>
    );
};

export default Payout;
